import LegalPage from "@/pages/legal/components/LegalPage";
import { privacyPolicy } from "@/mocks/legal";

export default function Page() {
  return <LegalPage data={privacyPolicy} />;
}